import { createSvgIcon } from '@mui/material'

export const ExamAttendance = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' width='30' height='20' viewBox='0 0 34 42.16'>
    <g id='_6330812' data-name='6330812' transform='translate(-56 504)'>
      <path
        id='Path_270'
        data-name='Path 270'
        d='M56.213-503.788l-.212.2V-467.7l.212.2c.2.2.247.212,1.36.212H58.72v1.147c0,1.114.009,1.165.213,1.36s.246.212,1.36.212H61.44v1.148c0,1.113.008,1.164.213,1.36l.2.213H84.178l2.907-2.916L90-467.663v-30.481l-.212-.2c-.2-.2-.247-.213-1.36-.213H87.28v-1.147c0-1.113-.008-1.164-.212-1.36s-.247-.212-1.36-.212H84.56v-1.147c0-1.113-.008-1.164-.212-1.36l-.2-.212H56.417ZM83.2-501.96v.68H59.137l-.2.212-.213.2v32.224H57.36v-34H83.2Zm2.72,2.72v.68H61.857l-.2.213-.213.2v32.224H60.08v-34H85.92Zm2.72,16.32v14.28H83.617l-.2.212-.213.2v5.023H62.8v-34H88.64Zm-1.02,15.665c0,.009-.689.706-1.53,1.547l-1.53,1.53v-3.1h1.53C86.932-467.28,87.62-467.272,87.62-467.255Z'
        transform='translate(0)'
        fill='#fff'
      />
      <path
        id='Path_271'
        data-name='Path 271'
        d='M191.427-391.816a8.807,8.807,0,0,0-7.234,7.361,8.74,8.74,0,0,0,2.576,7.658,7.6,7.6,0,0,0,2.142,1.539,8.7,8.7,0,0,0,7.956.025,8.255,8.255,0,0,0,2.38-1.776,7.5,7.5,0,0,0,1.547-2.15,8.7,8.7,0,0,0-.025-7.956A7.7,7.7,0,0,0,199.2-389.3,8.78,8.78,0,0,0,191.427-391.816Zm2.762,1.343a7.311,7.311,0,0,1,4,2.091,7.407,7.407,0,0,1,.969,9.367,7.617,7.617,0,0,1-4.505,3.179,8.977,8.977,0,0,1-3.561-.025,7.483,7.483,0,0,1-5.627-7.633,7.488,7.488,0,0,1,6.52-7.038A9.294,9.294,0,0,1,194.19-390.473Z'
        transform='translate(-117.195 -102.528)'
        fill='#fff'
      />
      <path
        id='Path_272'
        data-name='Path 272'
        d='M233.991-343.554a2.873,2.873,0,0,0-1.827,1.5l-.212.425-.026,3.417-.025,3.426h1.368v-2.04h2.72v2.04h1.368l-.025-3.426-.025-3.417-.289-.535a2.548,2.548,0,0,0-2.21-1.419A3.3,3.3,0,0,0,233.991-343.554Zm1.385,1.513c.544.408.57.484.6,2.244l.025,1.607h-2.729v-1.479a10.077,10.077,0,0,1,.094-1.725,1.442,1.442,0,0,1,.714-.757A1.577,1.577,0,0,1,235.377-342.041Z'
        transform='translate(-160.949 -146.769)'
        fill='#fff'
      />
      <path
        id='Path_273'
        data-name='Path 273'
        d='M313.36-311.32v.68H312v1.36h1.36v1.36h1.36v-1.36h1.36v-1.36h-1.36V-312h-1.36Z'
        transform='translate(-234.24 -175.68)'
        fill='#fff'
      />
      <path
        id='Path_274'
        data-name='Path 274'
        d='M160.191-167.809c-.212.2-.212.221-.212,1.828,0,2.185-.145,2.04,2.04,2.04s2.04.145,2.04-2.04.145-2.04-2.04-2.04C160.412-168.021,160.4-168.021,160.191-167.809Zm2.508,1.828v.68h-1.36v-1.36h1.36Z'
        transform='translate(-95.139 -307.419)'
        fill='#fff'
      />
      <path
        id='Path_275'
        data-name='Path 275'
        d='M224-167.32v.68h9.52V-168H224Z'
        transform='translate(-153.72 -307.44)'
        fill='#fff'
      />
      <path
        id='Path_276'
        data-name='Path 276'
        d='M224-135.32v.68h14.28V-136H224Z'
        transform='translate(-153.72 -336.72)'
        fill='#fff'
      />
      <path
        id='Path_277'
        data-name='Path 277'
        d='M408-135.32v.68h1.36V-136H408Z'
        transform='translate(-322.08 -336.72)'
        fill='#fff'
      />
      <path
        id='Path_278'
        data-name='Path 278'
        d='M160.191-103.809c-.212.2-.212.221-.212,1.827,0,2.185-.145,2.04,2.04,2.04s2.04.145,2.04-2.04.145-2.04-2.04-2.04C160.412-104.021,160.4-104.021,160.191-103.809Zm2.508,1.827v.68h-1.36v-1.36h1.36Z'
        transform='translate(-95.139 -365.979)'
        fill='#fff'
      />
      <path
        id='Path_279'
        data-name='Path 279'
        d='M224-103.32v.68h9.52V-104H224Z'
        transform='translate(-153.72 -366)'
        fill='#fff'
      />
      <path
        id='Path_280'
        data-name='Path 280'
        d='M224-71.32v.68h8.84V-72H224Z'
        transform='translate(-153.72 -395.28)'
        fill='#fff'
      />
      <path
        id='Path_281'
        data-name='Path 281'
        d='M344-71.32v.68h1.36V-72H344Z'
        transform='translate(-263.52 -395.28)'
        fill='#fff'
      />
    </g>
  </svg>,
  'Exam Attendance'
)
